<template>
  <div>
    <Navbar></Navbar>
    <div class="perform-draw">
      <div class="event-name">
        {{event_name}}
        <img
          data-toggle="modal"
          data-target="#cancelModal"
          class="header-action cancel"
          src="@/assets/images/x.svg"
        >
      </div>
      <h2 class="prize-name">{{this.prizeInfo.name}}</h2>
      <h4 class="winner-indicator">
        Winner {{ reSpinData ? reSpinData.position : current_winner}}
        <span
          class="total-winners"
        >of {{total_winners}}</span>
      </h4>
      <div :class="winnerClass">
        <label v-if="this.state == 'spinning'" class="spinning">Spinning...</label>
        <template v-if="this.state == 'result'">
          <h1
            class="winner winner-name"
          >{{ selected_attendee.firstname+" "+selected_attendee.lastname }}</h1>
          <h1 class="winner winner-email">{{ selected_attendee.email }}</h1>
          <h2 class="winner-field">#{{ selected_attendee.ticket_no }}</h2>
        </template>
      </div>
      <div :class="actionBtnClass">
        <button
          v-if="this.state == 'result'"
          :class="buttonDefault"
          :style="{color: btn_default_color}"
          @click="toggleRejectMenu()"
        >
          <span>{{secondary_action}}</span>
          <div v-if="this.state == 'result' && this.showRejectMenu" class="reject-options">
            <button
              @click="performSecondaryAction('respin')"
              class="dropdown-item respin"
              data-toggle="modal"
              data-target="#rejectModal"
              type="button"
            >Reject and respin</button>
            <button
              @click="performSecondaryAction('moveon')"
              class="dropdown-item move-on"
              data-toggle="modal"
              data-target="#rejectModal"
              type="button"
            >Reject and move on</button>
          </div>
        </button>
        <button
          v-else
          :class="buttonDefault"
          @click="performSecondaryAction('skip')"
          :style="{color: btn_default_color}"
        >
          <FullLoader :loading="createLoading"/>
          {{secondary_action}}
        </button>
        
        <button
          :class="buttonPrimary"
          :style="{color: btn_primary_color}"
          :disabled="disabled_confirm_button"
          @click="performPrimaryAction()"
        >{{primary_action}}</button>
      </div>
      <div id="rejectModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Reason for rejection</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <textarea v-model="rejectReason" type="text" class="form-control" rows="3" cols="40"/>
              <div class="error-message">{{this.errorReason}}</div>

              <div class="modal-btn-container">
                <button class="btn btn-default spin" @click="dismissRejectModal()">Cancel</button>
                <button class="btn btn-primary" @click="rejectAction()">{{modalConfirmText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="cancelModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Are you Sure?</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <p
                class="cancel-warning"
              >Cancelling the draw will reset it back to default state and all winners info will be erased.</p>
              <div class="modal-btn-container">
                <button class="btn btn-default spin" @click="dismissCancelModal()">Cancel</button>
                <button class="btn btn-primary" @click="cancelDraw()">Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="finishModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Attention!</h2>
              </div>
              <p class="cancel-warning">
                There are no more attendees on whom to perform the draw. You can either finish this draw
                (all remaining winners will be blank) or cancel the draw (all previous winners info will be discarded).
              </p>
              <div class="modal-btn-container">
                <button class="btn btn-default spin" @click="cancelDraw()">Cancel the draw</button>
                <button class="btn btn-primary" @click="finishDraw()">Finish the draw</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="leaveModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Are you Sure?</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <p
                class="cancel-warning"
              >Leaving the draw will reset it back to default state and all winners info will be erased.</p>
              <div class="modal-btn-container">
                <button class="btn btn-default spin" data-dismiss="modal">Cancel</button>
                <button class="btn btn-primary" @click="cancelDraw()">Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="resumeModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Attention!</h2>
              </div>
              <p class="cancel-warning">
                There is a draw in progress. Click
                <span style="font-weight: 600">Continue</span> if you wish to continue the draw. Click
                <span style="font-weight: 600">Cancel</span> to cancel the draw.
              </p>
              <div class="modal-btn-container">
                <button
                  class="btn btn-default spin"
                  data-dismiss="modal"
                  @click="cancelDraw()"
                >Cancel</button>
                <button class="btn btn-primary" @click="dismissResumeModal">Continue</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { log } from "async";
import FullLoader from "@/components/FullLoader";
import Navbar from "@/components/Navbar";
var $ = require("jquery");
export default {
  created() {},
  name: "PerformDraw",
  data() {
    return {
      loading: false,
      event_name: localStorage.getItem("event_name"),
      total_winners: 3,
      current_winner: 1,
      state: "spin",
      winner_animate: false,
      btn_default_color: "buttonText",
      btn_primary_color: "#fff",
      selected_attendee: {
        name: "",
        email: "",
        ticket_no: ""
      },
      respin: true,
      rejectReason: "",
      showRejectMenu: false,
      createLoading: false,
      errorReason: "",
      disabled_confirm_button: false
    };
  },
  components: {
    FullLoader,
    Navbar
  },
  props: ["prizeInfo", "reSpinData"],
  mounted() {
    document.getElementsByTagName(
      "title"
    )[0].innerText = `Perform Draw • GEVME Lucky Draw`;
    Event.$on("Home clicked", () => {
      $("#leaveModal").modal();
    });
    $(document).mouseup(
      function(e) {
        var container = $(".reject-options");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          this.showRejectMenu = false;
        }
      }.bind(this)
    );
    if (this.reSpinData) {
      this.state = "respin";
    } else if (this.prizeInfo.draws.length > 0) {
      if (
        this.prizeInfo.draws[this.prizeInfo.draws.length - 1].status ==
        "processing"
      ) {
        this.state = "result";
        this.current_winner = this.prizeInfo.draws[
          this.prizeInfo.draws.length - 1
        ].position;
        Object.assign(
          this.selected_attendee,
          this.prizeInfo.draws[this.prizeInfo.draws.length - 1].selectedAttendee
        );
        $("#resumeModal").modal();
      } else {
        if (
          this.prizeInfo.winnerCount ==
          Math.max(...this.prizeInfo.draws.map(draw => draw.position))
        ) {
          this.$router.push({
            name: "DrawSummary",
            params: {
              prizeInfo: this.prizeInfo
            }
          });
        } else {
          this.current_winner =
            this.prizeInfo.draws[this.prizeInfo.draws.length - 1].position + 1;
          $("#resumeModal").modal();
        }
      }
    }
    this.total_winners = this.prizeInfo.winnerCount;
  },
  methods: {
    dismissResumeModal() {
      $("#resumeModal").modal("hide");
    },
    dismissRejectModal() {
      $("#rejectModal").modal("hide");
    },
    dismissCancelModal() {
      $("#cancelModal").modal("hide");
    },
    dismissModal() {
      $("#leaveModal").modal("hide");
    },
    finishDraw() {
      $("#finishModal").modal("hide");
      this.$router.push({
        name: "DrawSummary",
        params: {
          prizeInfo: this.prizeInfo
        }
      });
    },
    performPrimaryAction() {
      switch (this.state) {
        case "spin":
          this.state = "spinning";
          axios
            .post(
              window.ENDPOINT,
              {
                query: `
                            mutation {
                                createDraw(prizeId:"${this.prizeInfo.id}") {
                                    id
                                    position
                                    selectedAttendee
                                    status
                                }
                            }
                        `
              },
              {
                headers: {
                  Authorization: localStorage.getItem("gevme_token")
                }
              }
            )
            .then(
              function(response) {
                if (response.data.errors) {
                  if (response.data.errors[0].message == "No more attendees") {
                    $("#finishModal").modal("show");
                  }
                } else {
                  this.state = "result";
                  Object.assign(
                    this.selected_attendee,
                    response.data.data.createDraw.selectedAttendee
                  );
                }
              }.bind(this)
            );
          break;
        case "respin":
          this.state = "spinning";
          axios
            .post(
              window.ENDPOINT,
              {
                query: `
                            mutation {
                                createDraw(prizeId:"${this.reSpinData.prizeId}",
                                    drawIdOfPosition: "${
                                      this.reSpinData.drawIdOfPosition
                                    }"
                                ) {
                                    id
                                    position
                                    selectedAttendee
                                    status
                                }
                            }
                        `
              },
              {
                headers: {
                  Authorization: localStorage.getItem("gevme_token")
                }
              }
            )
            .then(
              function(response) {
                if (response.data.errors) {
                  if (response.data.errors[0].message == "No more attendees") {
                    $("#finishModal").modal("show");
                  }
                } else {
                  this.state = "result";
                  Object.assign(
                    this.selected_attendee,
                    response.data.data.createDraw.selectedAttendee
                  );
                }
              }.bind(this)
            );
          break;
        case "result":
          $(".btn.draw-action").attr("disabled", "disabled");
          if (
            this.current_winner < this.total_winners &&
            this.reSpinData == undefined
          ) {
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                            mutation {
                                updateDraw(status: "accept", prizeId:"${
                                  this.prizeInfo.id
                                }")
                            }
                        `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  $(".btn.draw-action").removeAttr("disabled");
                  if (response.data.data.updateDraw.status == "accept") {
                    this.winner_animate = true;
                    this.btn_default_color = "transparent";
                    this.btn_primary_color = "transparent";
                    setTimeout(() => {
                      this.current_winner++;
                      this.winner_animate = false;
                      this.btn_default_color = "buttonText";
                      this.btn_primary_color = "#fff";
                      this.state = "spin";
                    }, 500);
                  }
                  // this.state = "result";
                  // Object.assign(this.selected_attendee, response.data.data.createDraw.selectedAttendee);
                }.bind(this)
              );
          } else {
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                            mutation {
                                updateDraw(status: "accept", prizeId:"${
                                  this.prizeInfo.id
                                }")
                            }
                        `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  $(".btn.draw-action").removeAttr("disabled");
                  if (response.data.data.updateDraw.status == "accept") {
                    this.$router.push({
                      name: "DrawSummary",
                      params: {
                        prizeInfo: this.prizeInfo
                      }
                    });
                  }
                }.bind(this)
              );
          }
          break;
        default:
          break;
      }
    },
    performSecondaryAction(param) {
      switch (param) {
        case "skip":
          $(".btn.draw-action").attr("disabled", "disabled");
          this.createLoading = true;
          if (this.reSpinData == undefined) {
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                        mutation {
                            updateDraw(status: "skip", prizeId:"${
                              this.prizeInfo.id
                            }")
                        }
                    `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  $(".btn.draw-action").removeAttr("disabled");
                  if (response.data.data.updateDraw.status === "skip") {
                    this.createLoading = false;
                    if (this.current_winner < this.total_winners)
                      this.current_winner++;
                    else {
                      this.$router.push({
                        name: "DrawSummary",
                        params: {
                          prizeInfo: this.prizeInfo
                        }
                      });
                    }
                  }
                }.bind(this)
              );
          } else {
            $(".btn.draw-action").removeAttr("disabled");
            this.$router.push({
              name: "DrawSummary",
              params: {
                prizeInfo: this.prizeInfo
              }
            });
          }
          break;

        case "respin":
          this.respin = true;
          break;

        case "moveon":
          this.respin = false;
          break;

        default:
          break;
      }
    },
    toggleRejectMenu() {
      this.showRejectMenu = !this.showRejectMenu;
    },
    rejectAction() {
      this.errorReason =
        this.rejectReason.length === 0 ? "Reason cannot be empty" : "";
      if (this.errorReason === "") {
        switch (this.respin) {
          case true:
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                            mutation {
                                updateDraw(status: "respin",
                                reason: "${this.rejectReason}",
                                prizeId:"${this.prizeInfo.id}")
                            }
                        `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  if (response.data.data.updateDraw.status == "respin") {
                    $("#rejectModal").modal("hide");
                    this.rejectReason = "";
                    this.state = "spin";
                    this.performPrimaryAction();
                  }
                }.bind(this)
              );
            break;

          case false:
            axios
              .post(
                window.ENDPOINT,
                {
                  query: `
                            mutation {
                                updateDraw(status: "move",
                                reason: "${this.rejectReason}",
                                prizeId:"${this.prizeInfo.id}")
                            }
                        `
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("gevme_token")
                  }
                }
              )
              .then(
                function(response) {
                  if (response.data.data.updateDraw.status == "move") {
                    $("#rejectModal").modal("hide");
                    this.rejectReason = "";
                    if (this.reSpinData == undefined) {
                      if (this.current_winner < this.total_winners) {
                        this.current_winner++;
                        this.state = "spin";
                      } else {
                        this.$router.push({
                          name: "DrawSummary",
                          params: {
                            prizeInfo: this.prizeInfo
                          }
                        });
                      }
                    } else {
                      this.$router.push({
                        name: "DrawSummary",
                        params: {
                          prizeInfo: this.prizeInfo
                        }
                      });
                    }
                  }
                }.bind(this)
              );
            break;

          default:
            break;
        }
      }
    },
    cancelDraw() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                    mutation {
                        updateDraw(status: "cancel", prizeId:"${
                          this.prizeInfo.id
                        }")
                    }
                `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            this.$router.push("/");
            // this.state = "result";
            // Object.assign(this.selected_attendee, response.data.data.createDraw.selectedAttendee);
          }.bind(this)
        );
    }
  },
  computed: {
    primary_action() {
      switch (this.state) {
        case "spin":
        case "respin":
          return "Spin";
          break;
        case "spinning":
          return "Spin";
          break;
        case "result":
          return this.current_winner < this.total_winners
            ? "Confirm"
            : "Confirm and Show Summary";
          break;
        default:
          return "Spin";
          break;
      }
    },
    secondary_action() {
      switch (this.state) {
        case "spin":
        case "respin":
          return "Skip";
          break;
        case "spinning":
          return "Skip";
          break;
        case "result":
          return "Reject";
          break;

        default:
          break;
      }
    },
    buttonPrimary() {
      return this.state == "spinning"
        ? "btn btn-primary spin draw-action disabled"
        : "btn btn-primary draw-action spin";
    },
    buttonDefault() {
      return this.state == "spinning"
        ? "btn btn-default draw-action spin dropdown-toggle disabled"
        : "btn btn-default draw-action spin dropdown-toggle";
    },

    winnerClass() {
      return this.winner_animate
        ? "winner-container winner-reset"
        : "winner-container";
    },
    actionBtnClass() {
      return this.winner_animate
        ? "action-btn-container winner-reset-btn"
        : "action-btn-container";
    },
    modalConfirmText() {
      return this.respin
        ? "Confirm and Respin"
        : "Confirm and move on to next winner";
    }
  }
};
</script>

<style scoped>
.perform-draw {
  text-align: center;
  margin-top: 70px;
}
.event-name {
  text-transform: uppercase;
  font-size: 12px;
  color: #4f5f73;
}
h2.prize-name {
  font-size: 35px;
  font-weight: bold;
  color: #4f5f73;
}
h4.winner-indicator {
  font-size: 25px;
  font-weight: 600;
  color: #323c48;
  margin-top: 20px;
}
span.total-winners {
  font-size: 15px;
}
.winner-container {
  min-height: 200px;
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.winner-reset {
  animation-name: winnerAnim;
  animation-duration: 0.55s;
}
.winner-reset-btn {
  animation-name: winnerBtnAnim;
  animation-duration: 0.75s;
}
.btn {
  transition: color 0.35s;
}
.btn-primary {
  min-width: 150px;
}
.btn-primary.spin {
  min-width: 150px;
  font-size: 14px;
  font-weight: 600;
  background-color: #0088ff;
}
.btn-default.spin {
  min-width: 150px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
}
.btn-default:focus,
.btn-primary:focus {
  box-shadow: none;
}
label.spinning {
  font-size: 30px;
  text-transform: uppercase;
  font-weight: 600;
  color: #323c48;
  margin-left: 30px;
}
h1.winner {
  font-size: 40px;
  font-weight: 800;
  color: #323c48;
}
h1.winner.winner-email {
  color: #5e6977;
}
h2.winner-field {
  font-weight: 35px;
  font-weight: 600;
  columns: #323c48;
  margin-top: 5px;
}
.dropdown-toggle::after {
  display: none;
}
.reject-options > .dropdown-item {
  font-size: 14px;
  color: #5e6977;
  cursor: pointer;
}
.dropdown-item.move-on {
  color: #de5c4d;
}
.reject-options {
  position: absolute;
  left: -50px;
  box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #e1e8ee;
  background-color: #fff;
  padding: 5px 0;
  border-radius: 4px;
}
.header-action.cancel {
  position: absolute;
  left: 30%;
  cursor: pointer;
}

.header-action.modal-close {
  cursor: pointer;
}

.modal-dialog {
  margin: 10rem auto;
  max-width: 670px;
}
.modal-body {
  padding: 45px;
}

.modal-body .title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modal-body .title h2 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 35px;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
}

.action-btn-container {
  position: relative;
}
p.cancel-warning {
  font-size: 20px;
  color: #323c48;
  text-align: left;
}

.reject-options:before {
  position: absolute;
  top: -8px;
  right: 35px;
  display: inline-block;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ccc;
  border-left: 8px solid transparent;
  border-bottom-color: #dce3e8;
  content: "";
}

.reject-options:after {
  position: absolute;
  top: -7px;
  right: 36px;
  display: inline-block;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ffffff;
  border-left: 7px solid transparent;
  content: "";
}
.error-message {
  font-size: 13px;
  color: red;
  font-weight: 300;
}
</style>





// WEBPACK FOOTER //
// src/components/PerformDraw.vue